import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaUser, FaLock, FaShieldAlt } from 'react-icons/fa';
import BrandLogo from '../components/BrandLogo';
import { BRAND } from '../utils/sst';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('sessionExpired')) {
      setSessionExpired(true);
      localStorage.removeItem('sessionExpired');
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login({ email, password });
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Correo o contraseña incorrectos');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-3"
      style={{ background: `linear-gradient(135deg, ${BRAND.primary} 0%, #0a3559 100%)` }}
    >
      <div style={{ maxWidth: 420, width: '100%' }}>
        <div className="text-center mb-4">
          <div className="d-inline-flex justify-content-center mb-2">
            <BrandLogo size={54} light />
          </div>
          <div style={{ color: '#bfe0f2', fontSize: 14, fontWeight: 500, letterSpacing: '0.02em' }}>
            SST lista para SUNAFIL
          </div>
        </div>

        <div className="card border-0 shadow-lg" style={{ borderRadius: 18 }}>
          <div className="card-body p-4 p-md-5">
            <h1 style={{ fontSize: 20, fontWeight: 800, color: BRAND.ink, marginBottom: 4 }}>Iniciar sesión</h1>
            <p className="text-muted" style={{ fontSize: 13, marginBottom: 22 }}>
              Panel de gestión de Seguridad y Salud en el Trabajo
              {process.env.REACT_APP_VERSION && (
                <span style={{ marginLeft: 6, opacity: 0.6 }}>v{process.env.REACT_APP_VERSION}</span>
              )}
            </p>

            {error && <div className="alert alert-danger py-2" style={{ fontSize: 13 }}>{error}</div>}
            {sessionExpired && (
              <div className="alert alert-warning py-2" style={{ fontSize: 13 }}>
                Tu sesión expiró. Vuelve a iniciar sesión.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label" style={{ fontSize: 13, fontWeight: 600, color: BRAND.slate }}>
                  <FaUser className="me-2" />Correo electrónico
                </label>
                <input
                  type="email" className="form-control form-control-lg" id="email"
                  style={{ fontSize: 15 }}
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  required autoComplete="email" disabled={isLoading}
                />
              </div>

              <div className="mb-4">
                <label htmlFor="password" className="form-label" style={{ fontSize: 13, fontWeight: 600, color: BRAND.slate }}>
                  <FaLock className="me-2" />Contraseña
                </label>
                <input
                  type="password" className="form-control form-control-lg" id="password"
                  style={{ fontSize: 15 }}
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  required autoComplete="current-password" disabled={isLoading}
                />
              </div>

              <button type="submit" className="btn btn-previx btn-lg w-100 fw-bold" disabled={isLoading} style={{ borderRadius: 10 }}>
                {isLoading ? (
                  <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Ingresando…</>
                ) : (
                  <><FaShieldAlt className="me-2" />Ingresar</>
                )}
              </button>
            </form>
          </div>
        </div>

        <div className="text-center mt-4" style={{ color: '#9dc3dc', fontSize: 12 }}>
          © {new Date().getFullYear()} Previx · Seguridad y Salud en el Trabajo
        </div>
      </div>
    </div>
  );
};

export default Login;
